/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
import icon from './icon';
import save from './save';
import transforms from './transforms';
export var name = 'core/shortcode';
export var settings = {
  title: __('Shortcode'),
  description: __('Insert additional custom elements with a WordPress shortcode.'),
  icon: icon,
  category: 'widgets',
  transforms: transforms,
  supports: {
    customClassName: false,
    className: false,
    html: false
  },
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map